module.exports = __webpack_public_path__ + "img/rpjh-sqlc-t.eabdc5a1.png";